<template>
  <section
    v-if="page.content_blocks && page.content_blocks.length > 0"
    class="content wrapper"
    :class="{ home: isHomePage }"
  >
    <div :key="block._id" class="content" v-for="block in page.content_blocks">
      <div class="inner">
        <div class="heading">{{ block.heading }}</div>
        <div>
          <div :class="{ col: block.image, cols: !block.image }" v-html="block.text"></div>
          <div class="col" v-if="block.image">
            <img :src="block.image" class="acc" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex"

export default {
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content:nth-child(odd) .col:first-child {
  float: right;
  padding-right: 0;
  padding-left: 0;
}
.content:nth-child(odd) .col:last-child {
  float: left;
  padding-right: 5%;
  padding-left: 0;
}

.content {
  padding: 4rem 0;
  clear: both;
  font-size: 2rem;
}
.content.home {
  padding: 0 0;
}

.content >>> p {
  margin-bottom: 3rem;
  display: inline-block;
  vertical-align: top;
  width: 100%;
}

.content >>> ul {
  margin-left: 3rem;
  margin-bottom: 2rem;
}
.content >>> p a {
  color: #c1d62f;
}
.col {
  width: calc(50% - 2.5rem);
  float: left;
  margin-top: 0px;
}
.cols {
  width: 100%;
  columns: 2;
  column-gap: 5rem;
}
.col:first-child {
  margin-right: 5rem;
}
.col img {
  width: 100%;
}

@media screen and (max-width: 750px) {
  .col {
    width: 100%;
    margin-right: 0 !important;
  }
  .col:first-child {
    padding-bottom: 3rem;
  }
  .cols {
    columns: 1;
  }
}
@media screen and (max-width: 650px) {
  .heading {
    font-size: 3rem;
  }
}
</style>
